import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Page::Plant::PlantAssets::AreaDetails\n  @plantAssetArea={{this.model}}\n  @plantAsset={{this.model.plantAsset}}\n/>")